import { defineStore } from 'pinia'
import { fetchWrapper } from '@/helpers/fetch-wrapper'

export const useCacheStore = defineStore({
  id: 'cache',
  state: () => ({
    cards: JSON.parse(localStorage.getItem('cards')),
    unitProgress: JSON.parse(localStorage.getItem('unitProgress')),
    dashboard: JSON.parse(localStorage.getItem('dashboard')),
  }),
  actions: {
    async fetch(key, url) {
      const response = await fetchWrapper.get(url)
      this[key] = response;
      localStorage.setItem(key, JSON.stringify(response));
    },
    async process(key, url, processFunction) {
      if (this,key) {
        processFunction(this[key])
        this.fetch(key, url).then(() => {
          processFunction(this[key])
        })
      }
      else {
        await this.fetch(key, url)
        processFunction(this[key])
      }
    }
  }
});

